module.exports = __webpack_public_path__ + "static/media/de.a40adc05.svg";